import { sameCountryName } from './countries.mjs';

const normalize = (value) => String(value ?? '').normalize('NFKC').trim().toLocaleLowerCase();

export function matchesWatchRule(article, rule) {
  const target = normalize(rule?.value);
  if (!target) return false;
  if (rule.kind === 'country') return Boolean(article.country && sameCountryName(article.country, String(rule.value).trim()));
  if (rule.kind === 'publisher') return normalize(`${article.sourceName || ''} ${article.publisherDomain || ''}`).includes(target);
  if (rule.kind === 'keyword') return normalize(`${article.title || ''} ${article.summary || ''}`).includes(target);
  return false;
}

export function findWatchMatches(article, rules = []) {
  return rules.filter((rule) => rule.enabled && matchesWatchRule(article, rule));
}
